export class ServiceAppointmentQueryParameters {
  actioned?: string;
  appointmentDateFrom?: string;
  appointmentDateTo?: string;
  equityThreshold?: number;
  inEquity?: string;
  originalSalespersonId?: string;
  page?: number;
  pageSize?: number;
  rooftopId?: string;
  salespersonId?: string[];
  saleStatusId?: string[];
  saleTypeId?: string[];
  serviceAdvisorId?: string[];
  sort?: string;
  termFrom?: number;
  termTo?: number;
  userEmployeeId?: string;
  vehicleId?: string;

  constructor(obj?: ServiceAppointmentQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
